(function ($) {

  var positions = [];

  function getParentClassLocationHash() {
    var locationHash = location.hash.replace('#', '');
    if (!/^[a-zA-Z0-9_-]+$/.test(locationHash)) {
      return '';
    }
    return $('a[name=' + locationHash + ']').parent().attr('class');
  }

  function initPositions() {
    if (positions.length === 0) {
      $('.image-container div').each(function () {
        positions.push($(this).attr('class').split('-')[1]);
      });
    }
  }

  function filterItems(items, itemToFilter) {
    return items.filter(function (item) {
      return item !== itemToFilter;
    });
  }

  function hideAllImageContent() {
    positions.forEach(function (position) {
      $('.content-' + position).hide();
    });
  }

  function showAllImages() {
    positions.forEach(function (position) {
      $('.image-' + position).show('slow');
    });
  }

  function showImageAndContent(itemPosition) {
    $('.content-' + itemPosition).show();
    $('.image-' + itemPosition).show();

    filterItems(positions, itemPosition).forEach(function (filteredPosition) {
      $('.content-' + filteredPosition).hide();
      $('.image-' + filteredPosition).hide();
    });
  }

  function areAllImagesVisible() {
    return positions.every(function (position) {
      return $('.image-' + position).is(':visible');
    });
  }

  function attachClickHandler() {
    $('#notWhatYouSee').click(function (e) {
      e.preventDefault();
      hideAllImageContent();
      showAllImages();
      $(this).hide();
    });
  }

  function attachImageListeners() {
    positions.forEach(function (position) {
      $('.image-' + position).click(function () {
        filterItems(positions, position).forEach(function (filteredPosition) {
          $('.content-' + filteredPosition).hide('slow');
          $('.image-' + filteredPosition).hide('slow');
        });
        $('#notWhatYouSee').show();
        $('.content-' + position).show();
        $('.image-container').get(0).scrollIntoView();
      });
    });
  }

  function toggleNotWhatYouSeeVisibility() {
    if (areAllImagesVisible()) {
      $('#notWhatYouSee').hide();
    } else {
      $('#notWhatYouSee').show();
    }
  }

  function onLocationHashChange() {
    var className = getParentClassLocationHash();
    var itemPosition = className ? className.split('-')[1] : '';

    var isLocationHashPresent = window.location.hash && getParentClassLocationHash();
    if (!isLocationHashPresent) {
      hideAllImageContent();
    }

    if (itemPosition) {
      showImageAndContent(itemPosition);
    }

    toggleNotWhatYouSeeVisibility();
  }

  function attachEventHandlers() {
    attachClickHandler();
    attachImageListeners();
    $(window).on('hashchange', function () {
      onLocationHashChange();
    });
  }

  function ready() {
    if ($('.article-container').length) {
      initPositions();
      attachEventHandlers();
      toggleNotWhatYouSeeVisibility();
      if (window.location.hash) {
        $(window).trigger('hashchange');
      }
    }
  }

  $(document).ready(ready);

}(jQuery));
